import React, { SyntheticEvent, useState } from "react";
import { Box, Tab, Tabs, Button, Typography, Paper, Pagination, styled } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RoutineStyle from "../../GlobalPolicies/RoutineUpload.module.css";
import Filter from "../Filter/Filter";
import checkManagementMatch from './ChangeManagementTabs';
import { apiService } from "../../../api/apiService";
import ReuploadComponent from "./ReuploadComponent";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


interface RoutineTabsProps {
  tabValue: string;
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[];
  counts: { All: number; Pending: number; Approved: number; Reverted: number };
  verticalTabValue: string;
  verticalTabs: { label: string; value: string }[];
  isLoading: boolean;
  filteredRoutineData: any[];
  paginatedData: any[];
  routineData: any[];
  itemsPerPage: number;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
  handleViewClick: (id: any,
      function_l1: any,
      function_l2: any,
      function_l3: any,
      function_l4: any,
      created_at: any,
      updated_at: any,
      updated_by: any,
      management: any,
      section_name: any,
      doc_path: any,
      file_size: any,
      file_name: any,
      status: any,
      manager_id: any,
      created_by: any,
      updated_by_email: any,
      approver_id: any,
      reason_to_approve: any,
      reason_to_reject: any,
      reason_to_revert: any) => void;
  setOpenUpload: (open: boolean) => void;
  getFileImagePath: (doc_path: string) => string;
  handleVerticalTabChange?: (event: React.SyntheticEvent, newValue: string) => void;
  isMcrTab?: boolean;
  handleApplyFilter?: (function_l1: string, function_l2: string, function_l3: string, function_l4: string) => void;
  level4?: boolean;
  level3?: boolean;
  level1?: boolean;
  level2?: boolean;
  functionL1?: any;
  functionL2?: any;
  functionL3?: any;
  functionL4?: any;
  question?: any;
  fileUploadText?: any;
  initialValues?: {
    l1?: string;
    l2?: string;
    l3?: string;
    l4?: string;
  };
  reuploadapiEndpoint?: string;
  onSuccess?: () => void;


}

const RoutineTabs: React.FC<RoutineTabsProps> = ({
  tabValue,
  handleTabChange,
  tabStatuses,
  counts,
  verticalTabValue,
  verticalTabs,
  isLoading,
  filteredRoutineData,
  paginatedData,
  routineData,
  itemsPerPage,
  handleChangePage,
  handleViewClick,
  setOpenUpload,
  getFileImagePath,
  handleVerticalTabChange,
  isMcrTab,
  handleApplyFilter,
  level4,
  functionL1,
  functionL2,
  functionL3,
  functionL4,
  level3,
  level1,
  level2,
  question,
  fileUploadText,
  initialValues = {
    l1: '',
    l2: '',
    l3: '',
    l4: ''
  },

  reuploadapiEndpoint,
  onSuccess

}) => {
  const { instance } = useMsal();

  const [filterValues, setFilterValues] = useState({
    l1: '',
    l2: '',
    l3: '',
    l4: ''
  });



  const StyledTableRow = styled(Box)<{ status: string }>(({ status }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    boxShadow: `4px 0px 0px 0px ${status === 'Approved'
      ? '#058B2B'
      : status === 'Reverted'
        ? '#e53935'
        : status === 'Pending'
          ? '#FF5C00'
          : 'transparent'
      } inset`,
  }));

  // function handleVerticalTabChange(event: SyntheticEvent<Element, Event>, value: any): void {
  //   throw new Error("Function not implemented.");
  // }

  const getAppliedFilterString = (functionL1: string, functionL2: string, functionL3: string, functionL4: string): string => {
    const filters = [];
    if (functionL1) filters.push(`L1: ${functionL1}`);
    if (functionL2) filters.push(`L2: ${functionL2}`);
    if (functionL3) filters.push(`L3: ${functionL3}`);
    if (functionL4) filters.push(`L3: ${functionL4}`);
    return filters.length > 0 ? filters.join(', ') : 'None';
  };

  const management = localStorage.getItem('management') || '';
  const apiManagement = localStorage.getItem('apiManagement') || '';
  // Check if management matches apiManagement
  const isManagementMatching = management === apiManagement;


  const handleReupload = async (itemId: string, file: File): Promise<void> => {
    if (!reuploadapiEndpoint) return;

    const formData = new FormData();
    formData.append("file", file);


    try {
      const response = await apiService(`${reuploadapiEndpoint}/${itemId}`, "POST", formData, undefined, instance as PublicClientApplication);

      if (response.status !== "success") {
        throw new Error(response.message || "Failed to upload file");
      }

      // Refresh data after successful upload
      onSuccess?.();
    } catch (error) {
      console.error("Reupload error:", error);
      throw new Error(typeof error === 'string' ? error : "Failed to upload file");
    }
  };



  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={tabValue}>
        <Box sx={{ display: "flex", justifyContent: "space-between", borderColor: "divider" }}>
          <Box className={RoutineStyle.tabs_routine}>
            <TabList

              onChange={handleTabChange}
              aria-label="SIPOC Tabs"
            >
              {tabStatuses.map((tab) => (
                <Tab
                  key={tab.value}
                  label={`${tab.label} (${counts[tab.value] || 0})`}
                  value={String(tabStatuses.indexOf(tab) + 1)} // Ensure the value matches the index
                  sx={{ textTransform: 'none', fontWeight: '400' }}
                />
              ))}
            </TabList>
            <Button
              variant="contained"
              className={RoutineStyle.uploadBtn}
              onClick={() => setOpenUpload(true)}
              disabled={!isManagementMatching} // Disable button if management doesn't match apiManagement
            >
              Upload
            </Button>
          </Box>
        </Box>

        <TabPanel value={tabValue}>
          <Box sx={{ display: "flex" }}>
            {isMcrTab && (
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={verticalTabValue}
                onChange={handleVerticalTabChange}
                aria-label="Vertical Tabs"
                sx={{ minWidth: "150px", textAlign: 'left' }}
                className="vertical_rTabs"

              >
                {verticalTabs.map((tab) => (
                  <Tab key={tab.value} label={tab.label} value={tab.value} />
                ))}
              </Tabs>
            )}

            {isLoading ? (
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: "center",
                  backgroundColor: "transparent",
                  height: "500px",
                  pt: 0,
                }}
              >
                <Typography className={RoutineStyle.noFileText}>
                  Fetching Files...
                </Typography>
              </Paper>
            ) : (
              <>
                <Box sx={{ marginLeft: 2, flexGrow: 1 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      // textAlign: "center",
                      backgroundColor: "transparent",
                      height: "500px",
                      pt: 0,
                    }}
                  >
                    <Box
                      className='routineHeader'
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        // mb: 3,
                        // backgroundColor: '#fff',
                        // padding: 2,
                        // borderRadius: '11px',
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{ fontFamily: 'Avantt', fontWeight: '600' }}
                        >
                          {verticalTabs.find((tab) => tab.value === verticalTabValue)?.label}
                        </Typography>

                        <Typography sx={{ color: '#000', fontSize: '16px', }}>
                          {question}
                        </Typography>

                      </Box>

                      {level1 && (
                        <Filter
                          levels={1}
                          onApplyFilter={handleApplyFilter || (() => { })}
                          initialValues={{
                            l1: initialValues?.l1 || '',
                            l2: '',
                            l3: '',
                            l4: ''
                          }}
                        />
                      )}

                      {level2 && (
                        <Filter
                          levels={2}
                          onApplyFilter={handleApplyFilter || (() => { })}
                          initialValues={{
                            l1: initialValues?.l1 || '',  // Required for L2
                            l2: initialValues?.l2 || '',
                            l3: '',
                            l4: ''
                          }}
                        />
                      )}

                      {level3 && (
                        <Filter
                          levels={3}
                          onApplyFilter={handleApplyFilter || (() => { })}
                          initialValues={{
                            l1: initialValues?.l1 || '',  // Required for L3
                            l2: initialValues?.l2 || '',  // Required for L3
                            l3: initialValues?.l3 || '',
                            l4: ''
                          }}
                        />
                      )}

                      {level4 && (
                        <Filter
                          levels={4}
                          onApplyFilter={handleApplyFilter || (() => { })}
                          initialValues={{
                            l1: initialValues?.l1 || '',  // Required for L4
                            l2: initialValues?.l2 || '',  // Required for L4
                            l3: initialValues?.l3 || '',  // Required for L4
                            l4: initialValues?.l4 || ''
                          }}
                        />
                      )}


                    </Box>


                    <Box sx={{ textAlign: 'left', py: 2 }}>
                      <Typography component="span" sx={{ color: '#696969' }}>
                        Filter:&nbsp;&nbsp;
                      </Typography>
                      <Typography component="span" sx={{ fontWeight: 600 }}>
                        {/* show here applied filter value seprated by comma */}
                        {getAppliedFilterString(functionL1, functionL2, functionL3, functionL4)}

                      </Typography>
                    </Box>

                    {counts[tabStatuses[Number(tabValue) - 1].value] === 0 ? (
                      <Typography className={RoutineStyle.noFileText}>
                        File not found for the selected status.
                      </Typography>
                    ) : filteredRoutineData.length > 0 ? (
                      <Box>
                        {paginatedData.map((item) => (
                          <StyledTableRow sx={{ mb: 2 }} status={item.status}>
                            <Paper key={item.id} className={RoutineStyle.bordercard} sx={{ width: '100%' }}>

                              <Box sx={{ display: "flex", gap: "50px", p: 2 }}>

                                <div style={{ display: "flex", textAlign: "left", gap: "5px", width: '30%' }}>
                                  <div>
                                    <img src={getFileImagePath(item.doc_path)} alt="File" height={50} width={50} />
                                  </div>
                                  <div>
                                    <p>{item.file_name.split("_").slice(5).join("_")}</p>
                                    <h4>{item.file_size || "Unknown Size"}</h4>
                                  </div>
                                </div>

                                  <div style={{ textAlign: "left", width: "20%" }}>
                                    <h4>Function L1</h4>
                                    <p>{item.function_l1 || '--'}</p>
                                  </div>





                                  <div style={{ textAlign: "left", width: "20%" }}>
                                    <h4>Function L2</h4>
                                    <p>{item.function_l2 || '--'}</p>
                                  </div>


                                  <div style={{ textAlign: "left", width: "20%" }}>
                                    <h4>Function L3</h4>
                                    <p>{item.function_l3 || '--' }</p>
                                  </div>

                                  <div style={{ textAlign: "left", width: "20%" }}>
                                    <h4>Function L4</h4>
                                    <p>{item.function_l4 || '--'}</p>
                                  </div>

                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Create Date</h4>
                                  <p>{new Date(item.created_at).toLocaleDateString()}</p>
                                </div>
                                <div style={{ textAlign: "left", width: "20%" }}>
                                  <h4>Status</h4>
                                  <p
                                    className={RoutineStyle.statuspending}
                                    style={{
                                      color:
                                        item.status === 'Reverted'
                                          ? '#F00'
                                          : item.status === 'Approved'
                                            ? '#058B2B'
                                            : item.status === 'Pending'
                                              ? '#FF5C00'
                                              : '#000',
                                    }}
                                  >
                                    {item.status}
                                  </p>
                                </div>

                              </Box>

                              <hr />

                              {(item.status === "Approved" || item.status === "Reverted") && (
                                <Box sx={{ padding: '10px' }}>
                                  <Paper
                                    elevation={1}
                                    sx={{
                                      textAlign: 'left',
                                      borderRadius: '6px',
                                      border: `1px solid ${item.status === 'Reverted' ? 'red' : '#058B2B'}`,
                                      backgroundColor: item.status === 'Reverted' ? '#ffebeb' : '#e6ffed',
                                      padding: '10px',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: item.status === 'Reverted' ? 'red' : '#058B2B',
                                      }}
                                    >
                                      {item.status === "Approved" ? "Approved Reason" : "Reverted Reason"}
                                    </Typography>
                                    <Typography sx={{ paddingTop: '6px' }}>
                                      {item.status === "Approved" ? item.reason_to_approve : item.reason_to_revert}
                                    </Typography>
                                  </Paper>
                                </Box>
                              )}

                              <Box sx={{ display: "flex", gap: 2, alignItems: 'center', justifyContent: "flex-end", padding: "10px", borderRadius: "9px" }}>
                                {item.status === "Reverted" && (
                                  <ReuploadComponent
                                    itemId={item.id}
                                    onReupload={handleReupload}
                                    onSuccess={onSuccess}
                                  />
                                )}
                                <Button
                                  onClick={() => handleViewClick(
                                    item.id,
                                    item.function_l1,
                                    item.function_l2,
                                    item.function_l3,
                                    item.function_l4,
                                    item.created_at,
                                    item.updated_at,
                                    item.updated_by,
                                    item.management,
                                    item.section_name,
                                    item.doc_path,
                                    item.file_size,
                                    item.file_name,
                                    item.status,
                                    item.manager_id,
                                    item.created_by,
                                    item.updated_by_email,
                                    item.approver_id,
                                    item.reason_to_approve,
                                    item.reason_to_reject,
                                    item.reason_to_revert 
                                  )}
                                  className={RoutineStyle.black_btn}
                                >
                                  View
                                </Button>
                              </Box>

                            </Paper>
                          </StyledTableRow>
                        ))}

                        {filteredRoutineData.length > 3 && (
                          <Pagination
                            color="primary"
                            count={Math.ceil(filteredRoutineData.length / itemsPerPage)}
                            onChange={handleChangePage}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mt: 2,
                              "& .MuiPaginationItem-root": {
                                color: "black",
                              },
                              "& .MuiPaginationItem-ellipsis": {
                                color: "black",
                              },
                              "& .MuiPaginationItem-icon": {
                                color: "black",
                              },
                            }}
                          />
                        )}
                      </Box>
                    ) : (
                      <Typography className="routinePara" variant="body1" gutterBottom>
                        <Typography variant="h6" sx={{ textAlign: 'center' }}>
                          There's no file uploaded right now
                        </Typography>
                        <Typography sx={{ textAlign: 'center' }}>
                          {fileUploadText}
                        </Typography>
                        <Button
                          variant="contained"
                          className={RoutineStyle.border_btn}
                          onClick={() => setOpenUpload(true)}
                          disabled={!isManagementMatching} // Disable button if management doesn't match apiManagement
                        >
                          Upload
                        </Button>
                      </Typography>
                    )}
                  </Paper>
                </Box>
              </>
            )}
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default RoutineTabs;